import React, { useEffect } from "react";
import { Provider as ReduxProvider } from "react-redux";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { ThemeProvider } from "styled-components";
import { LoadingSpinner } from "ctech-react-components";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { loadInitialConfig } from "config/appConfig";
import Routes from "routes";
import { ToastContainer } from "react-toastify";

import { AuthProvider, useAuth } from "context/AuthContext";
import AppProvider from "context";

import store from "store";

import * as themeConfig from "styles/themes";
import GlobalStyle from "styles/global";
import { useAppSelector } from "store/hooks";
import { clarityManager } from "libs/clarity/clarity";

function Spinner() {
  const { isSpinnerVisible } = useAppSelector((state) => state.appConfig);
  const { isAuthLoading } = useAuth();

  return (
    <LoadingSpinner isSpinnerVisible={isSpinnerVisible || isAuthLoading} />
  );
}

function ToastIcon({ type }: { type?: string }) {
  switch (type) {
    case "success":
      return <CheckCircleOutlineIcon sx={{ fontSize: 24 }} />;
    case "error":
      return <InfoOutlinedIcon sx={{ fontSize: 24 }} />;
    default:
      return null;
  }
}

const App = () => {
  useEffect(() => {
    loadInitialConfig();
  }, []);

  useEffect(() => {
    clarityManager.init();
  }, []);

  return (
    <AuthProvider>
      <ReduxProvider store={store}>
        <AppProvider>
          <MuiThemeProvider theme={themeConfig.defaultTheme}>
            <ThemeProvider theme={themeConfig.defaultTheme}>
              <GlobalStyle />
              <Spinner />
              <Routes />
              <ToastContainer icon={ToastIcon} />
            </ThemeProvider>
          </MuiThemeProvider>
        </AppProvider>
      </ReduxProvider>
    </AuthProvider>
  );
};

export default App;
